export default [
  {
    path: '/strips',
    name: 'strips-list',
    component: () => import('@/views/strip/StripsList.vue'),
    meta: {
      resource: 'strips',
      action: 'view',
    },
  },
  {
    path: '/strips/builder/new',
    name: 'strip-builder-create',
    component: () => import('@/views/strip/builder/StripBuilderView.vue'),
    meta: {
      resource: 'strips',
      action: 'view',
    },
  },
  {
    path: '/strips/builder/:id',
    name: 'strip-builder',
    redirect: to => ({ name: 'strip-edit', params: { id: to.params.id } }),
    meta: {
      resource: 'strips',
      action: 'view',
    },
  },
  {
    path: '/strips/:id/edit',
    name: 'strip-edit',
    component: () => import('@/views/strip/StripEdit.vue'),
    meta: {
      navActiveLink: 'strips-list',
      resource: 'strips',
      action: 'view',
    },
  },
  {
    path: '/strips/import-archive',
    name: 'strip-import-archive',
    component: () => import('@/views/strip/import/StripImportArchive.vue'),
    meta: {
      resource: 'strips',
      action: 'view',
    },
  },
  {
    path: '/strips/import-siq',
    name: 'strip-import-siq',
    component: () => import('@/views/strip/import/StripImportSiq.vue'),
    meta: {
      resource: 'strips',
      action: 'view',
    },
  },
]
